import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ChartSignalEntry, Colors} from '@models/pages/user-defined-page/chart-signal-entry';
import {ChartConstants} from '@constants/pages/chart-constants';
import {
  ChartsConfigurationHelperService
} from '@services/charts/helper/charts-configuration-helper.service';
import {Signal} from '@models/dashboard/signal';
import {ChartsHelperService} from '@services/charts/helper/charts-helper.service';

@Component({
    selector: 'scitis-line-widget-axis-signal-item',
    templateUrl: './line-widget-axis-signal-item.component.html',
    styleUrls: ['./line-widget-axis-signal-item.component.scss'],
    standalone: false
})
export class LineWidgetAxisSignalItemComponent implements OnInit {
  @Input()
  signal: ChartSignalEntry = new ChartSignalEntry();
  @Output()
  signalRemoveFromAxis: EventEmitter<ChartSignalEntry> = new EventEmitter<ChartSignalEntry>();
  @Output()
  signalColorChanged: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  signalOriginalColor: string = ChartConstants.DEFAULT_LINE_COLOR;
  @Input()
  signalHasBeenDeleted: boolean = false;

  constructor(private chartsConfigurationHelperService: ChartsConfigurationHelperService,
              private chartsHelperService:ChartsHelperService) {
  }

  public get isColorOverwrite(): boolean {
    const originalColor = this.chartsConfigurationHelperService.normalizeColorToHex(this.signalOriginalColor);
    return originalColor !== this.getHexColor();
  }

  ngOnInit(): void {
    if (!this.signal.colors) {
      this.signal.colors = new Colors();
    }
  }

  onSelectSignalColor($event: string) {
    if (!$event || $event.isNullOrWhitespace()) {
      return;
    }
    this.signal.colors.main = this.chartsConfigurationHelperService.convertHexColorToNumber($event);
    this.signalColorChanged.emit($event);
  }

  getSignalUnit(signal: Signal | ChartSignalEntry) {
    return this.chartsHelperService.getSignalUnit(signal);
  }

  getHexColor() {
    if (!this.signal || !this.signal.colors || !this.signal.colors.main || this.signalHasBeenDeleted) {
      return ChartConstants.DEFAULT_LINE_COLOR;
    }

    return this.chartsConfigurationHelperService.convertNumberToHexColor(this.signal.colors.main);
  }

  onRemoveSignalFromAxis() {
    this.signalRemoveFromAxis.emit(this.signal);
  }

  onResetColorToSignalDefault() {
    const normalizedDefaultColor = this.chartsConfigurationHelperService.normalizeColorToHex(this.signalOriginalColor);
    const defaultColor = this.chartsConfigurationHelperService.convertHexColorToNumber(normalizedDefaultColor);
    this.signal.colors = {...this.signal.colors, main: defaultColor};
    this.signalColorChanged.emit(this.signalOriginalColor);
  }
}
